import { atom } from 'jotai'

// screen-size buckets evaluated once at module load, matching the previous
// useMemo-based ScreenSizeProvider which captured window.innerWidth at mount.
export const isSmallScreenAtom = atom<boolean>(window.innerWidth <= 768)
export const isLargeScreenAtom = atom<boolean>(window.innerWidth >= 1280)
